import { useCallback, useRef } from 'react'

/**
 * 自定义防抖 hook
 * @param {Function} callback - 要防抖的函数
 * @param {number} delay - 延迟时间（毫秒）
 * @returns {Function} 防抖后的函数
 */
export const useDebounce = (callback, delay) => {
  const timeoutRef = useRef(null)

  const debouncedCallback = useCallback(
    (...args) => {
      // 清除之前的定时器
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }

      // 设置新的定时器
      timeoutRef.current = setTimeout(() => {
        callback(...args)
      }, delay)
    },
    [callback, delay],
  )

  return debouncedCallback
}
